import { render, staticRenderFns } from "./Buses.vue?vue&type=template&id=dbd63de4&scoped=true&lang=html&"
import script from "./Buses.vue?vue&type=script&lang=js&"
export * from "./Buses.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbd63de4",
  null
  
)

export default component.exports